import { render, staticRenderFns } from "./WorkProcessForm.vue?vue&type=template&id=bcef36ee"
import script from "./WorkProcessForm.vue?vue&type=script&lang=js"
export * from "./WorkProcessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports